module.exports = __webpack_public_path__ + "img/add.435cdd1a.jpg";